import { handleError } from "@/utils/parseApiReturn";
import { ApiService } from "../../../config";
import { TEmbaixadorCode, TPixKey } from "../models";

interface ISendPixKeyProps {
  key: string;
  pixKeytype: string;
}

interface IWithdrawalProps {
  amount: number;
}

const sendPixKey = async ({
  pixKeytype,
  key
}: ISendPixKeyProps): Promise<TPixKey> => {
  try {
    const response = await ApiService.patch(`/ambassadors`, {
      pixKeytype,
      pixKeyvalue: key
    });

    return response.data;
  } catch (error) {
    return handleError(
      error,
      "Houve um problema ao se cadastrar como embaixador."
    );
  }
};

const setEmbaixador = async (): Promise<any> => {
  try {
    const data = await ApiService.post(`/users/set-ambassador`);

    if (data) {
      return data.data;
    }
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para tornar o usuário embaixador:"
    );
  }
};

const geTopDashboardData = async (): Promise<any> => {
  try {
    const response = await ApiService.get(`/ambassadors/top-dashboard`);

    return response.data.data;
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para recuperar os dados do dashboard"
    );
  }
};

const getDashboardData = async (
  page: number,
  searchParam: string,
  limit: number,
  orderBy: string
): Promise<any> => {
  try {
    const response = await ApiService.get(`/ambassadors/dashboard`, {
      page,
      searchParam,
      limit,
      orderBy
    });

    return response.data;
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para recuperar os dados do dashboard"
    );
  }
};

const withdrawal = async ({ amount }: IWithdrawalProps): Promise<any> => {
  try {
    const response = await ApiService.post(`/ambassadors/withdrawal`, {
      amount
    });

    return response.data;
  } catch (error) {
    return handleError(error, "Erro na requisição para solicitar saque");
  }
};

const getEmbaixadorData = async (): Promise<TEmbaixadorCode> => {
  try {
    const response = await ApiService.get(`/ambassadors/data`);
    return {
      success: true,
      message: "Dados do embaixador recuperados com sucesso",
      code: response.data.data.code
    };
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para recuperar os dados do embaixador:"
    );
  }
};

const getHistoryWithdrawal = async (
  page: number,
  limit: number
): Promise<any> => {
  try {
    const response = await ApiService.get(`/ambassadors/withdrawal`, {
      page,
      limit
    });

    if (response) {
      return response.data;
    }
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para recuperar os dados do histórico de saque:"
    );
  }
};

const getTermsConditions = async (): Promise<any> => {
  try {
    const result = await ApiService.get(`/ambassadors/terms-conditions`);

    if (result) {
      return result.data;
    }
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para recuperar os termos e condições:"
    );
  }
};

const setTermsConditions = async (): Promise<any> => {
  try {
    const result = await ApiService.post(`/ambassadors/terms-conditions`);

    if (result) {
      return result.data;
    }
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para aceitar os termos e condições:"
    );
  }
};
const getPixKey = async (): Promise<any> => {
  try {
    const result = await ApiService.get(`/ambassadors/pix-key`);

    if (result) {
      return result.data;
    }
  } catch (error) {
    return handleError(error, "Erro na requisição para recuperar a chave PIX:");
  }
};

export const EmbaixadorService = {
  sendPixKey,
  withdrawal,
  setEmbaixador,
  geTopDashboardData,
  getEmbaixadorData,
  getHistoryWithdrawal,
  getTermsConditions,
  setTermsConditions,
  getDashboardData,
  getPixKey
};
